
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.QueryResultActions';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';
import TreeView from 'share/components/controls/Izenda.TreeView';
import Input from 'share/components/controls/Izenda.Input';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import { toJS } from 'mobx';
import { get,remove ,isUndefined,every,some} from 'lodash/fp';
const QuerySource = 'QuerySource';
@connect(actions)
class QueryResult extends Component {
  
  renderNode = (item, toggleIcon, toggle, isCollapsed, parent) => {
    
    function getCheckedStatus(item)
    {      
      const nodeType = item.nodeType;
      if(nodeType==QuerySource)
      {
        if(isUndefined(item.checked))
        {
          const checked = item.nodes.length>0 ? every('checked', item.nodes) : false;
          //item.checked =checked;
          return checked;
        }
        
      }
      return item.checked;

    }
    return (
      <label className='overflow-text checkbox-inline'>
        <Input
          type='checkbox'
          indeterminate={item.indeterminate}
          checked={getCheckedStatus(item)}
          onChange={this.props.onChange.bind(this, item, parent)}
        />
        <OverflowText
          text={item.value}
          tooltip={item.value}
          className={item.nodeType == 'QuerySource' ? 'tablename' : ''}/>
      </label>
    );
  };
  searchBox() {
    const {exploreStore,reportDesignerFieldsStore,setTreeData} = this.props;
    let filterText='';
    const onChangeSearchText = e => {
      filterText=e.target.value;
      const availableTreeData = toJS(exploreStore.availableAllQuerySourceFields);
      let checkedFields = exploreStore.checkedQuerySources;

        availableTreeData.map(item=>{
          item.querySource.map(querySourceItem=>{

              let filteredQuerySourceFiled =[];
              querySourceItem.fields && querySourceItem.fields.map(querysourcefield=>{
                if (this.contains(querysourcefield.name,filterText)) {
                  //update query source field previous checked status in case there is no checkedFields 
                  querysourcefield.isCheck =  checkedFields.length>0 ? some(x=>x.field.id==querysourcefield.id,checkedFields) : false;  
                  filteredQuerySourceFiled.push(querysourcefield);
                }
      
              });

              querySourceItem.fields=filteredQuerySourceFiled;
            
            exploreStore.checkedQuerySources = remove(x=>isUndefined(x.field),exploreStore.checkedQuerySources);
          });
      });
    
      reportDesignerFieldsStore.dataTree.readDataSource(availableTreeData);
      setTreeData();

    };
   
    return (
        <SearchTextBox
          value={filterText}
          onChange={onChangeSearchText}/>
    );
  }

   contains = (text, term) => {
    return text.toLowerCase().includes(term.toLowerCase());
   }


  render() {
    const { props,props:{localization, displayTreeData,actionQueryWrapper, displayQueryWrapper} } = this;

    return (
     <div className='query-result-container'>
         <div className='add-column-wrapper' onClick={actionQueryWrapper}>
            <i className='arrow right'></i>
            <span className='add-column-label'>
                {localization.getText('QUERY_RESULT_ADD_COLUMNS')}
            </span>
         </div>
         {displayQueryWrapper &&
        <div className='query-result-wrapper'>
           {this.searchBox()}
           <TreeView
           nodes={displayTreeData}
           renderNode={this.renderNode}
           getKey={get('key')}
           getChildNodes={get('nodes')}
           collapsed={false}
            />

            <button className='btn btn-primary' onClick={props.onApplySeletedField}>
                {localization.getText('QUERY_RESULT_APPLY')}
           </button>
        </div>
       }


     </div>
    );
  }
}

export default QueryResult;



// WEBPACK FOOTER //
// ./ui/share/components/controls/QueryResult/Izenda.QueryResult.js